<template>
    <div>
        <Tabela  :headers="($vuetify.breakpoint.mdAndUp)?headers:headers.filter(f=>(f.value !== 'sigla' &&  f.value !== 'municipio' && f.value !== 'descricao'  ))" :desserts="instituicoesAll" :title="($vuetify.breakpoint.mdAndUp)?titulo:''" :icon="($vuetify.breakpoint.mdAndUp)?icone:''" @search="buscar"
            v-if="!showGrafico">
            <template v-slot:acoes>
                <v-col cols="12" md="4" class="text-right">
                    <v-select v-if="$vuetify.breakpoint.mdAndUp" class="year-select" :items="visualizacao" v-model="visualizacaoSelected"
                        @change="mudarVisualizacao()" item-value="id" item-text="descricao" label="Visualização"
                        outlined dense hide-details></v-select>
                </v-col>
            </template>
        </Tabela>

        <div class="dashboard-container" v-if="showGrafico">

            <div class="chart-container">
            <div class="header">
                <h1>Distribuição de Estudantes por Instituição</h1>
                <p class="subtitle">Top 10 instituições com maior número de estudantes</p>
                <v-select class="year-select" :items="visualizacao" v-model="visualizacaoSelected"
                        @change="mudarVisualizacao()" item-value="id" item-text="descricao" label="Visualização"
                        outlined dense hide-details></v-select>
            </div>
                <div class="chart-wrapper">
                    <GraficoInstituicoes :instituicoes="instituicoesAll" />
                </div>

                <div class="stats-container" v-if="instituicoesAll.length">
                    <div class="stat-card total">
                        <span class="stat-value">{{ totalEstudantes }}</span>
                        <span class="stat-label">Total de Estudantes</span>
                    </div>
                    <div class="stat-card institutions">
                        <span class="stat-value">{{ instituicoesAll.length }}</span>
                        <span class="stat-label">Instituições Cadastradas</span>
                    </div>
                    <div class="stat-card average">
                        <span class="stat-value">{{ mediaPorInstituicao }}</span>
                        <span class="stat-label">Média por Instituição</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "../../../plugins/axios";
const ls = require("local-storage");
import Tabela from "../componentes/configuracoes/Tabela-estatistica.vue";
import GraficoInstituicoes from "./componentes/GraficoInstituicoes.vue";

export default {
    components: {
        loading: () => import("../../../components/loading.vue"),
        Tabela,
         GraficoInstituicoes
    },
    data: () => ({
        isLoading: true,
        instituicoesAll: [],
        headers: [
            { text: '#', value: 'index', align: 'center',width: '200px'},
             { text: "Colégio", align: "left", value: "descricao" },
            { text: "Sigla", align: "left", value: "sigla" },
            { text: "Município", value: "municipio" },
            { text: "Estado", value: "enable" },
            { text: "Estudantes", value: "total_estudantes" },
            { text: "Licença", value: "licencaExpirada" },
            { text: "IMS Associado", value: "imsAssociado" }
        ],
        headersFilter: [],
        titulo: "Lista de Escolas e Status",
        icone: "mdi-school",
        visualizacao: [
            { id: 1, descricao: 'Visualizar Tabela' },
            { id: 2, descricao: 'Grafico Instituição Maior cadastro' },
        ],
        visualizacaoSelected: { id: 1, descricao: 'Visualizar Tabela' },
        showGrafico: false
    }),

     computed: {
        totalEstudantes() {
            return this.instituicoesAll.reduce((total, inst) => total + parseInt(inst.total_estudantes || 0), 0);
        },
        mediaPorInstituicao() {
            return this.instituicoesAll.length 
                ? Math.round(this.totalEstudantes / this.instituicoesAll.length)
                : 0;
        }
    },


    created() {
        this.carregarDadosIniciais();
    },

    methods: {
        async carregarDadosIniciais() {
            this.isLoading = true;
            await Promise.all([
                this.initializeInstituicoes(),
            ]);
            this.isLoading = false;
        },

        buscar(valor) {
            console.log(valor);
        },

        async initializeInstituicoes() {
            try {
                this.instituicoesAll = await axios.get("/getAllInstituicoes").then((res) => res.data);
            } catch (error) {
                Swal.fire('Informação', 'Erro', 'error')
            }
        },

        mudarVisualizacao() {
            if (this.visualizacaoSelected == 2) {
                this.showGrafico = true;
            } else {
                this.showGrafico = false;
            }
            console.log(this.visualizacaoSelected, ' a visualizacao select');
        }
    },
};
</script>

<style scoped>
.form-container {
    margin: 0 auto;
}

.year-select {
    margin-left: 20px;
}

.student-name {
    display: flex;
    align-items: center;
}

.action-btn {
    transition: all 0.3s ease;
}

.action-btn:hover {
    transform: scale(1.1);
}

.v-card-title {
    padding-bottom: 16px;
    border-bottom: 1px solid #eee;
    margin-bottom: 16px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
    .v-card-title {
        flex-direction: column;
        align-items: flex-start;
    }

    .year-select {
        margin-left: 0;
        margin-top: 10px;
        width: 100%;
        max-width: none;
    }
}

.dashboard-container {
    font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', sans-serif;
    margin: 0 auto;
    padding: 2rem;
    color: #2c3e50;
}

.header {
    margin-bottom: 2rem;
    text-align: center;
}

.header h1 {
    font-size: 2.2rem;
    font-weight: 600;
    color: #34495e;
    margin-bottom: 0.5rem;
}

.subtitle {
    font-size: 1.1rem;
    color: #7f8c8d;
}

.chart-container {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    padding: 2rem;
    margin-top: 1.5rem;
}

.chart-wrapper {
    position: relative;
    height: 400px;
    margin-bottom: 2rem;
}

.stats-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
    margin-top: 2rem;
}

.stat-card {
    padding: 1.5rem;
    border-radius: 10px;
    text-align: center;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-5px);
}

.stat-card.total {
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    color: white;
}

.stat-card.institutions {
    background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
    color: white;
}

.stat-card.average {
    background: linear-gradient(135deg, #f46b45 0%, #eea849 100%);
    color: white;
}

.stat-value {
    font-size: 2.5rem;
    font-weight: 700;
    display: block;
    margin-bottom: 0.5rem;
}

.stat-label {
    font-size: 1rem;
    opacity: 0.9;
}

@media (max-width: 768px) {
    .dashboard-container {
        padding: 1rem;
    }
    
    .stats-container {
        grid-template-columns: 1fr;
    }
    
    .header h1 {
        font-size: 1.8rem;
    }
}
</style>